import { MICRO_LABEL_TRACKING } from './MicroLabel';

/**
 * The white KPI box of the Financials contract aside (`ProjectBudgetAside`):
 * the panel surface with a hairline, unlike the sunken tiles below it, a
 * micro-label on top and a mono figure under it.
 *
 * Shared since 2026-10-29, when the task panel's Contract insights took the
 * same three boxes (allocated hours, forecasted revenue, forecasted factor)
 * so the two surfaces read alike. One definition, two readers — a copy in
 * Planning would have drifted the first time the aside was retouched.
 */
export const KPI_BOX_SX = {
  flex: '1 1 120px',
  minWidth: 0,
  bgcolor: 'var(--bg-panel)',
  border: 'var(--border-width-thin) solid var(--border-divider)',
  borderRadius: 'var(--border-radius-medium)',
  px: 1.5,
  py: 1,
} as const;

export const KPI_LABEL_SX = {
  fontSize: 10,
  color: 'var(--fg-3)',
  textTransform: 'uppercase',
  letterSpacing: MICRO_LABEL_TRACKING,
  mb: 0.5,
} as const;

export const KPI_VALUE_SX = {
  fontFamily: 'var(--font-family-mono)',
  fontSize: 20,
  fontWeight: 500,
  color: 'var(--fg-1)',
  lineHeight: 1,
} as const;
